export const isHtmlContent = (content: string): boolean => {
  return /<\/?[a-z][\s\S]*>/i.test(content);
};

